import React, { useMemo } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";



const contenedorMapa = {
  width: "100%",
  height: "350px",
  borderRadius: "12px",
  overflow: "hidden",
};

const bogota = {
  lat: 4.711,
  lng: -74.0721,
};

// Componente principal del mapa.
// Recibe coordenadas actuales (latitud y longitud) y una función `onChange`
// para notificar al componente padre cuando el usuario seleccione una nueva ubicación.
export default function MapaUbicacionServicio({ latitud, longitud, onChange, ubicacionUsuario }) {
  // console.log("latitud y longitud: ", latitud, " - ", longitud);
  // console.log("ubicacionUsuario: ", ubicacionUsuario);
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script-zervicy",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY || "",
  });

  // Si ya tenemos coordenadas del servicio, centramos el mapa allí.
  // Si no, usamos la ubicación del usuario cuando esté disponible.
  // Si tampoco existe, usamos Bogotá como punto inicial por defecto.
  const tieneUbicacionServicio = latitud != null && longitud != null;
  const tieneUbicacionUsuario =
    ubicacionUsuario?.permiso === "aprobado" &&
    ubicacionUsuario?.latitud != null &&
    ubicacionUsuario?.longitud != null;

  const centro = useMemo(() => {
    if (tieneUbicacionServicio) {
      return {
        lat: Number(latitud),
        lng: Number(longitud),
      };
    }

    if (tieneUbicacionUsuario) {
      return {
        lat: Number(ubicacionUsuario.latitud),
        lng: Number(ubicacionUsuario.longitud),
      };
    }

    return bogota;
  }, [tieneUbicacionServicio, tieneUbicacionUsuario, latitud, longitud, ubicacionUsuario]);

  const marcador = useMemo(() => {
    if (tieneUbicacionServicio) {
      return {
        lat: Number(latitud),
        lng: Number(longitud),
      };
    }

    return null;
  }, [tieneUbicacionServicio, latitud, longitud]);

  function seleccionarUbicacion(e) {
    const nuevaLatitud = e?.latLng?.lat?.();
    const nuevaLongitud = e?.latLng?.lng?.();

    if (nuevaLatitud == null || nuevaLongitud == null) return;
    onChange(nuevaLatitud, nuevaLongitud);
  }

  if (!GOOGLE_MAPS_API_KEY) {
    return (
      <div className="alert alert-warning mb-0">
        Falta configurar la variable <strong>REACT_APP_GOOGLE_MAPS_API_KEY</strong> para cargar Google Maps.
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="alert alert-danger mb-0">
        No fue posible cargar Google Maps. Revisa la API key o las restricciones del proyecto en Google Cloud.
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="alert alert-info mb-0">
        Cargando mapa...
      </div>
    );
  }

  return (
    <div style={contenedorMapa}>
      <GoogleMap
        mapContainerStyle={{ width: "100%", height: "100%" }}
        center={centro}
        zoom={13}
        onClick={seleccionarUbicacion}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: true,
        }}
      >
        {marcador && <Marker position={marcador} />}
      </GoogleMap>
    </div>
  );
}